import React from "react";
import styled from "styled-components";
import TextField from '@material-ui/core/TextField';
import {inject} from "mobx-react";
import i18n from "i18next";

const TitleEditorStyled = styled.div`
`;

@inject("uiStore")
class TitleEditor extends React.Component<any, any> {

    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        return (
            <TitleEditorStyled dir={this.props.uiStore.dir}>
                <TextField
                    fullWidth
                    variant="outlined"
                    id="standard-name"
                    label={i18n.t("Title")}
                    value={this.props.widget.data.title}
                    onChange={(event) => this.props.onUpdateData('title', event.target.value)}
                    margin="normal"
                />
                <div>
                    <TextField
                        variant="outlined"
                        fullWidth
                        id="standard-name"
                        label={i18n.t("Sub title")}
                        value={this.props.widget.data.subTitle}
                        onChange={(event) => this.props.onUpdateData('subTitle', event.target.value)}
                        margin="normal"
                    />
                </div>
            </TitleEditorStyled>
        );
    }
}

export default TitleEditor;

